import React from 'react';
import PropTypes from 'prop-types';

import UploadDropzone from "Components/UploadDropzone";
import Button from 'UI/Button';
import Modal from "UI/Modal";
import UploadList from "Components/UploadList";

export default class UploadDialog extends React.Component
{
    static propTypes = {
        onClose: PropTypes.func.isRequired,
    };

    render()
    {
        const {open, onClose} = this.props;

        return <Modal open={open} onClose={onClose} className='w-full max-w-md'>
            <Modal.Header>
                Media Upload
            </Modal.Header>
            <div className='p-4'>
                <UploadDropzone multiple />
            </div>
            <Modal.Content>
                <UploadList />
            </Modal.Content>
            <Modal.Footer>
                <Button onClick={onClose}>Close</Button>
            </Modal.Footer>
        </Modal>;
    }

}